import { render, staticRenderFns } from "./presetDialog.vue?vue&type=template&id=4799aed8&scoped=true"
import script from "./presetDialog.vue?vue&type=script&lang=js"
export * from "./presetDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4799aed8",
  null
  
)

export default component.exports